import { useState } from "react";
import { Text } from "react-native-paper";
import TextInput, { TextInputProps } from "./TextInput";

const TEXT_LIMIT = 500;

interface TextInputAreaProps extends TextInputProps {
  onChangeText: (text: string) => void;
}

const TextInputArea = ({ onChangeText, ...textInputprops }: TextInputAreaProps) => {
  const [textLength, setTextLength] = useState(0);
  const handleChangeText = (text: string) => {
    setTextLength(text.length);
    onChangeText(text);
  };

  return (
    <>
      <TextInput
        {...textInputprops}
        onChangeText={handleChangeText}
        maxLength={TEXT_LIMIT}
        className="h-36"
        multiline={true}
        numberOfLines={2}
      />

      {!textInputprops.error && (
        <Text className="text-ink-lighter tiny-none inter-500 pl-1 pt-2">
          {TEXT_LIMIT - textLength}/{TEXT_LIMIT} Characters Remaining
        </Text>
      )}
    </>
  );
};

export default TextInputArea;
